import styled from "styled-components";

import Button from '../../../components/Button';

export const DocumentDesktop = styled.div`
	display: flex;
	height: 100vh;
	padding: 2rem 5rem;
	flex: 1;
	display: flex;
	justify-content: center;
	background-color: #F5F5F5;
`;

DocumentDesktop.Term = styled.div`
	max-width: 85vh;
	height: 620px;
	margin-right: 1rem;
`;

DocumentDesktop.TermContainer = styled.div`
	height: 100%;
	box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
	background-color: #FFF;
	color: black;
	padding: 1rem 3rem;
	min-width: 514px;
`;

DocumentDesktop.TermTextContainer = styled.div`
	max-width: 85vh;
	min-height: 340px;
`;

DocumentDesktop.TermTitle = styled.div`
	text-transform: uppercase;
	font-weight: 500;
	font-size: 16px;
	margin: 1rem 0;
`;

DocumentDesktop.TermText = styled.div`
	margin-top: 1rem;
	font-weight: 400;
	font-size: 16px;
`;

DocumentDesktop.TermFooter = styled.div`
	display: flex;
	margin-top: 1rem;
	justify-content: center;
	text-align: center;
`;

DocumentDesktop.Signature = styled.div`
	width: 70vh;
	height: 280px;
	color: blue;
	background-color: purple;
	margin-left: 1rem;
	background-color: #FFF;
	border-radius: 5px;
`;

DocumentDesktop.SignatureContainer = styled.div`
	height: 100%;
	border-radius: 5px;
	box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
	background-color: #FFF;
	color: black;
	padding: 1rem 2rem;
`;

DocumentDesktop.SignatureCenter = styled.div`
	display: flex;
	justify-content: center;
`;

DocumentDesktop.SignatureTitle = styled.h1`
	font-size: 20px;
	color: #26282A;
	font-weight: 500;
`;

DocumentDesktop.SignatureText = styled.p`
	font-weight: 400;
	font-size: 16px;
	color: #4E5255;
	margin-top: 2rem;
`;

DocumentDesktop.UserContainer = styled.div`

`;

DocumentDesktop.UserName = styled.p`
	word-break: break-all;
	font-weight: 500;
	font-size: 16px;
	color: #26282A;
	line-height: 20px;
`;

DocumentDesktop.Cpf = styled.p`
	font-weight: 400;
	font-size: 14px;
	color: #4E5255;
	line-height: 20px;
`;


DocumentDesktop.ImageSuccess = styled.img`
	width: 64px;
	height: 64px;
`;

DocumentDesktop.AnchorProps = styled.a`
	width: 100%;
	margin: 16px 0;
	margin-top: 2rem;
`;

DocumentDesktop.Button = styled.button`
	color: #26282A;
	margin-top: 1rem;
	border: 1px solid #D9E1E8;
	border-radius: 8px;
	height: 50px;
	display: flex;
	width: 100%;
	justify-content: center;
`;

DocumentDesktop.ButtonText = styled.p`
	font-size: 16px;
	color: #FFF;
`;

DocumentDesktop.FooterSignature = styled.div`
	width: 100%;
	border: 1px solid #D9E1E8;
	cursor: pointer;
	margin-top: 2rem;
	background: white;
	border-radius: 8px;
	height: 100px;
	padding: 8px 16px;

	@media only screen and (min-width: 601px) {
		display: flex;
		justify-content: ${({ hasSignature }) => hasSignature ? 'center' : 'normal' };
	}
`;

DocumentDesktop.FooterSignature.Placeholder = styled.span`
	fnt-weight: 400;
	font-size: 16px;
	line-height: 24px;
	color: #767B7F;
`;

DocumentDesktop.FooterSignature.Image = styled.img`
	width: 180px;
	margin: 0 auto;
	height: 80px;
`;

DocumentDesktop.FooterSignature.Button = styled(Button)`
	margin-top: 16px;
`;
